import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { noop, Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseUrlHelperService } from '../helper/baseUrlHelper.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private log: NGXLogger,
    private http: HttpClient,
    private _apiroot: BaseUrlHelperService,
    private cookieService: CookieService,  ) { }
 
  logout() {
    this.log.trace("logout() ");
    window.localStorage.clear();
    this.cookieService.deleteAll("/");
    window.location.href = window.location.origin + "/api/logout";
    //return this.http.post(this._apiroot.baseUrl + "home/logout", null);
  }

  ping(): Observable<any> {
    return this.http.get(this._apiroot.baseUrl + "ping");
  }
}
